import '@dodilio/ui-design-lib/main.css'
import {DodilTheme} from "@dodilio/ui-design-lib";
import { createRoot } from "react-dom/client";
import {Provider} from 'jotai';
import {FC, ReactNode, StrictMode } from "react";
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import {HelmetProvider} from "react-helmet-async";
import {CreateAccount} from './pages/CreateAccount';
import {VerifyAccount} from './pages/VerifyAccount';
import {AcceptInviteAccount} from './pages/AcceptInvite';
import {CreateOrg} from './pages/CreateOrg';
import {ClientInvite} from './pages/ClientInvite';
import {ResetPassword} from './pages/ResetPassword';
import {SignupContinue} from './pages/SignupContinue';
import {iamStore} from './state';
import './main.css';
import "./layout.css"
import { rememberReturnTo } from './returnTo';
import { rememberReferral, stripRefParam } from './referral';
import { rememberClientInvite, stripInviteParam } from './clientInvite';
import { captureSignupLink, stripSignupLink } from './signupLink';

rememberReturnTo();
// A partner's `?ref=CODE`: kept for the org step, then dropped from the
// address bar so it does not travel into bookmarks or shared links.
rememberReferral(window.location.search);
// A partner's client invitation, `?invite=TOKEN`: kept for the whole signup,
// dropped from the address bar, and the visitor starts on its page.
const invited = rememberClientInvite(window.location.search);
// From Keycloak's sign-in page: the typed email, and whether to start Google sign-up.
captureSignupLink(window.location.search, window.location.hash);
{
    const stripped = stripSignupLink(window.location.search, window.location.hash);
    const search = stripInviteParam(stripRefParam(stripped.search));
    // iam's accept_url may land on / or /invite/ (no code: not an org invite).
    const pathname = invited && /^\/(invite\/?)?$/.test(window.location.pathname) ? '/client-invite' : window.location.pathname;
    if (search !== window.location.search || stripped.hash !== window.location.hash || pathname !== window.location.pathname) {
        window.history.replaceState(window.history.state, '', pathname + search + stripped.hash);
    }
}

const AppLoader: FC<{ children: ReactNode }> = ({ children }) => {
    return <>{children}</>;
};

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <HelmetProvider>
            <Provider store={iamStore}>
                <BrowserRouter basename="/">
                    <DodilTheme accentColor={"purple"} hasBackground={true} appearance={"light"} >
                        <AppLoader>
                            <Routes>
                                <Route path="/" element={<CreateAccount />} />
                                <Route path="/verify" element={<VerifyAccount />} />
                                <Route path="/signup/org" element={<CreateOrg />} />
                                <Route path="/invite/:code" element={<AcceptInviteAccount />} />
                                <Route path="/client-invite" element={<ClientInvite />} />
                                <Route path="/reset" element={<ResetPassword />} />
                                <Route path="/signup/continue" element={<SignupContinue />} />
                            </Routes>
                        </AppLoader>
                    </DodilTheme>
                </BrowserRouter>
            </Provider>
        </HelmetProvider>
    </StrictMode>
);
